import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-900 group-[.toaster]:border-2 group-[.toaster]:shadow-2xl group-[.toaster]:rounded-xl group-[.toaster]:p-4 group-[.toaster]:text-base group-[.toaster]:font-semibold group-[.toaster]:min-h-[70px]",
          description: "group-[.toast]:text-gray-700 group-[.toast]:text-base group-[.toast]:mt-1",
          actionButton:
            "group-[.toast]:bg-blue-600 group-[.toast]:text-white group-[.toast]:font-bold group-[.toast]:px-4 group-[.toast]:py-2 group-[.toast]:rounded-lg",
          cancelButton:
            "group-[.toast]:bg-gray-200 group-[.toast]:text-gray-800 group-[.toast]:font-semibold group-[.toast]:px-4 group-[.toast]:py-2 group-[.toast]:rounded-lg",
          success: "group-[.toast]:border-green-500 group-[.toast]:bg-green-50",
          error: "group-[.toast]:border-red-500 group-[.toast]:bg-red-50",
          warning: "group-[.toast]:border-yellow-500 group-[.toast]:bg-yellow-50",
          info: "group-[.toast]:border-blue-500 group-[.toast]:bg-blue-50",
        },
        style: {
          fontSize: '16px',
          fontWeight: '600',
        }
      }}
      {...props} />
  );
}

export { Toaster, toast }
